import { ETC } from '../types';
export default {
  type: ETC,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/etc',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
